import React from "react";
// import Banner from "./components/Banner";
// import Navbar from "./components/Navbar";
import "./styles/app.scss";
// import SponserContainer from "./components/SponserContainer";
import ComingSoon from "./components/ComingSoon";
import DynamicFavicon from "./utils/DynamicFevicon";

function App() {
  return (
    // <div className="app-container">
    //   <div className="navbar-container">
    //     <Navbar />
    //   </div>
    //   <div className="banner-container">
    //     <Banner />
    //   </div>
    //   <div style={{borderBottom:"1px solid rgba(255, 255, 255, 0.1)", margin:"0 !important"}} className="w-100 d-flex justify-content-center align-items-center">
    //     <SponserContainer />
    //   </div>
    //   <div  className="mt-5 pt-5 d-flex justify-content-center mb-5 pb-5">
    //     <img style={{width:"80vw"}} src={"/images/waveIcon.png"} alt="wave graph" />
    //   </div>
    // </div>
    <>
      <DynamicFavicon />
      <ComingSoon />
    </>
  );
}

export default App;
